// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"22279":"75c48ed31b07dd81","77633":"eb69229c20d0471f"}[chunkId] + ".css";
};